import Box from "@mui/material/Box";
import { styled } from "@mui/material/styles";
import Typography from "@mui/material/Typography";
import * as React from "react";

const Body = styled(Box)(({ theme }) => ({
  borderRadius: "15px",
  backgroundColor: "rgba(255,255,255,0.09803921568627451 )",
  display: "flex",
  flexDirection: "column",
  padding: "11px",
  gap: "5px",
  justifyContent: "center",
  alignItems: "start",
  width: "100%",
}));

const TicketTitleText = styled(Typography)(({ theme }) => ({
  color: "#c1c1c1",
  fontSize: "12px",
}));

const TicketText = styled(Typography)(({ theme }) => ({
  color: "#ffffff",
  fontSize: "20px",
}));

interface cardsProps {
  type: string;
  ticket: number;
}

const FundDetailSubCards: React.FC<cardsProps> = ({type,ticket}) => {
  return (
    <Body>
      {type === "total" ? <TicketTitleText>Your Total Tickets</TicketTitleText> 
      : type === "submitted" ? <TicketTitleText>Your submitted tickets</TicketTitleText>
        : <TicketTitleText>Tickets in the jackpot</TicketTitleText>}
      <TicketText>{ticket}</TicketText>
    </Body>
  );
};

export default FundDetailSubCards;
